<template>
  <div class="mod-notice">
    <a-layout class="layout" >
      <a-space direction="vertical" size="middle">
        <div class="mod-notice-top" :style="{textAlign: 'center', backgroundColor: '#fff'}">
          <div class="logo" >
            <a-icon type="user-delete" :style="{ fontSize: '40px', marginBottom: '10px' }" />
          </div>
          <h3>申请永久注销用户</h3>
          <p :style="{color: '#CB0303'}">账号注销后，您将无法使用当前帐号</p>
          <p :style="{color: '#CB0303'}">相关数据也将被删除无法找回，请谨慎操作</p>
        </div>
        <div class="mod-notice-center" :style="{textAlign: 'center', backgroundColor: '#fff'}">
          <a-row>
            <a-col :span="8" class="mod-notice-center-left">
              <div>
                <a-icon type="user" :style="{ fontSize: '30px', marginBottom: '5px' }" />
                <p>当前账号</p>
              </div>
            </a-col>
            <a-col :span="2" class="mod-notice-center-center">
              <a-divider type="vertical" />
            </a-col>
            <a-col :span="14" class="mod-notice-center-right">
              <a-descriptions :column='1' :style="{textAlign: 'left'}">
                <a-descriptions-item label="用户名">
                  {{ userInfo.fullName || '-' }}
                </a-descriptions-item>
                <a-descriptions-item label="手机号">
                  {{ userInfo.phone || '-'  }}
                   <span v-if="userInfo.phone">
                     <user-icon v-if="userInfo.phoneStatus !== 0" class="icon-warn" type="icon-jinggaoicon"></user-icon>
                      {{ userInfo.phoneStatus | contactStatus }}
                    </span>
                </a-descriptions-item>
                <a-descriptions-item label="邮箱">
                  {{ userInfo.email || '-' }}
                  <span v-if="userInfo.email">
                    <user-icon v-if="userInfo.emailStatus !== 0" class="icon-warn" type="icon-jinggaoicon"></user-icon>
                    {{ userInfo.emailStatus | contactStatus }}
                  </span>
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
          </a-row>
        </div>
        <div class="mod-notice-bottom" :style="{textAlign: 'center', backgroundColor: '#fff'}">
          <div class="content" :style="{textAlign: 'left'}" v-html="noticeContent"> </div>
          <div class="action">
              <a-button class="full-btn" type="primary" size="large" @click="onOk" >同意须知并注销</a-button>
          </div>
        </div>
      </a-space>
    </a-layout>
  </div>
</template>

<script>
const contactStatusMap = {
  8: '易主',
  0: '已验证',
  2: '未验证',
  '-1': '未绑定',
  '-2': '删除'
}

export default {
  props: {
    userInfo: Object,
    noticeContent: String
  },
  methods: {
    onCancel () {
      history.go(-1)
    },
    onOk () {
      this.$emit('noticeCheck')
    }
  },
  filters: {
    contactStatus (value) {
      if (typeof value === 'undefined') {
        return '-'
      }

      return contactStatusMap[value] || value
    }
  }
}
</script>
